//#region imported =====================================================================================

'use strict';
const packageJson = require('../package.json');
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { config: publicConfig } = publicRuntimeConfig;
// console.info(`web: publicRuntimeConfig:`, publicRuntimeConfig);
// console.info(`web: publicRuntimeConfig NODE_ENV=${publicRuntimeConfig.NODE_ENV}, CONFIG_ENV=${publicRuntimeConfig.CONFIG_ENV}`);
const CONFIG_ENV = (process.env.CONFIG_ENV) || (publicRuntimeConfig.CONFIG_ENV) || (process.env.NODE_ENV) || (publicRuntimeConfig.NODE_ENV);

if (typeof (console) !== 'undefined') {
  var color = 'background-color:#1c5cbd';
  console.log('%c __        __               _                                   ', color);
  console.log('%c \\ \\      / /_ _ _ __ _ __ (_)_ __   __ _                       ', color);
  console.log('%c  \\ \\ /\\ / / _` | \'__| \'_ \\| | \'_ \\ / _` |                      ', color);
  console.log('%c   \\ V  V / (_| | |  | | | | | | | | (_| |                      ', color);
  console.log('%c    \\_/\\_/ \\__,_|_|  |_| |_|_|_| |_|\\__, |                      ', color);
  console.log('%c                                    |___/                       ', color);
  console.log('%c +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+', color);
  console.log('%c | S o m e o n e   c a n   s t e a l   y o u r   p r i v a c y |', color);
  console.log('%c | S h o u l d n \' t   p l a c e   a n y   c o d e   h e r e ! |', color);
  console.log('%c +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+', color);
  console.log('%c |                  J e n o s i z e  T e a m                   |', color);
  console.log('%c +-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+', color);
}
console.info(`web: version=${packageJson.version}`);
if (!publicRuntimeConfig.IS_DEBUG) {
  console.info(`web: disable console.log, info, warn`);
  console.log = () => { };
  console.info = () => { };
  console.warn = () => { };
} else {
  console.info(`web: NODE_ENV=${publicRuntimeConfig.NODE_ENV}, CONFIG_ENV=${CONFIG_ENV}`);
}

//#endregion ===========================================================================================

// #region Default config. =============================================================================

let configNext = {
  package: {
    name: packageJson.name,
    version: packageJson.version,
  },
  name: `JNZ-${packageJson.version}`,
  title: `JNZ-${packageJson.version}`,
  description: `JNZ-${packageJson.version}`,
  image: '',
  baseUrl: '',
  clientUrl: '',
  backendEndpoint: '',
  xApiKey: '',
  jnzAuthConfig: {},
  isOrderSlipDev: false,
  versionUrl: '',
  permissionValidate: {},
  bigCGateway: {},
};

//#end region Default config. ===========================================================================================
const {
  backendEndpoint,
  xApiKey,
  image,
  baseUrl,
  clientUrl,
  jnzAuthConfig,
  isOrderSlipDev,
  versionUrl,
  permissionValidate,
  bigCGateway,
} = publicConfig;

configNext.title = `${configNext.title}-${CONFIG_ENV}`;
configNext.backendEndpoint = backendEndpoint ? backendEndpoint : '';
configNext.xApiKey = xApiKey ? xApiKey : '';
configNext.image = image ? image : '';
configNext.baseUrl = baseUrl ? baseUrl : '';
configNext.clientUrl = clientUrl ? clientUrl : '';
configNext.jnzAuthConfig = jnzAuthConfig || {};
configNext.isOrderSlipDev = isOrderSlipDev;
configNext.versionUrl = versionUrl || '';
configNext.permissionValidate = permissionValidate || {};
configNext.bigCGateway = bigCGateway || {};

module.exports = configNext;


